<div class="new-home-container">
  <!-- Header and Menu are now provided by Shell wrapper -->
  <app-alert-popup></app-alert-popup>

  <app-banner></app-banner>
  <ng-container *ngIf="loadRemaining">
    <main class="new-home-content">
      <app-special-interest-section></app-special-interest-section>
      <app-where-to-stay></app-where-to-stay>

      <div class="background-section" [ngStyle]="{ 'background-image': backgroundImageUrl }">
        <app-whats-happening></app-whats-happening>
        <app-creole-section></app-creole-section>
        <h2 class="section-header blog-header-title">{{ 'Check out our Latest Blog Articles' | translate }}</h2>
      </div>

      <app-blog></app-blog>
    </main>
    <app-download-section></app-download-section>
    <app-crowdiff></app-crowdiff>
  </ng-container>
</div>

<!-- Footer is now provided by Shell wrapper -->
